<template>
  <div>
    <mia-form-section-grid :cols="5">
      <mia-feature-select
        :value="debtor"
        :errors="getErrors('debtor')"
        label="Debitor"
        :options="debtorOptions"
        track-by="id"
        name-by="item_title"
        disable-default-option
        @input="$emit('update:debtor', $event); clearErrors('debtor');"
      />

      <mia-feature-input
        :value="invoiceId"
        :errors="getErrors('invoice_id')"
        label="Rechnungsnummer"
        @input="$emit('update:invoiceId', $event); clearErrors('invoice_id');"
      />

      <mia-feature-input
        :value="date"
        :errors="getErrors('date')"
        label="Rechnungsdatum"
        type="date"
        @input="$emit('update:date', $event); clearErrors('date');"
      />

      <mia-feature-input
        :value="title"
        :errors="getErrors('title')"
        label="Beschreibung"
        @input="$emit('update:title', $event); clearErrors('title');"
      />

      <mia-feature-input
        :value="value"
        :errors="getErrors('value')"
        label="Betrag"
        type="number"
        step="0.01"
        @input="$emit('update:value', $event); clearErrors('value');"
      />
    </mia-form-section-grid>
  </div>
</template>

<script>
import { getDebtors } from '@/api/dealer'
import FormSectionGrid from '@/components/ui/widgets/FormSectionGrid.vue'
import FeatureSelect from '@/components/cars/edit/FeatureSelect.vue'
import FeatureInput from '@/components/cars/edit/FeatureInput.vue'
import HandlesBackendValidationErrors from '@/mixins/HandlesBackendValidationErrors'

export default {
  name: 'DebtForm',

  components: {
    'mia-feature-input': FeatureInput,
    'mia-feature-select': FeatureSelect,
    'mia-form-section-grid': FormSectionGrid
  },

  mixins: [HandlesBackendValidationErrors],

  props: {
    debtor: {
      type: [String, Number],
      required: true
    },

    invoiceId: {
      type: String,
      required: true
    },

    date: {
      type: String,
      required: true
    },

    title: {
      type: String,
      required: true
    },

    value: {
      type: [String, Number],
      required: true
    },

    errorsKey: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    debtors: []
  }),

  computed: {
    backendValidationErrorsKey() {
      return this.errorsKey
    },

    debtorOptions() {
      return [
        {
          id: 'customer',
          item_title: 'Kunde'
        },
        ...this.debtors
      ]
    }
  },

  created() {
    this.loadDebtors()
  },

  methods: {
    async loadDebtors() {
      const [errors, debtors] = await getDebtors()

      if (errors) {
        console.error(errors)
        window.eventBus.$emit('mia-error', {
          error: ['Debitoren konnten nicht geladen werden.']
        })
        return
      }

      this.debtors = debtors
    }
  }
}
</script>
